import { IndicateForm } from "../components/indicate-form";
import { Informations } from "../components/informations";

export function Indicate() {
  return (
    <div className="p-8 grid grid-cols-1 gap-8 text-white sm:grid-cols-2 sm:items-center sm:justify-items-center">
      <div className="max-w-full order-2 sm:order-1 sm:block">
        <div className="flex items-start gap-2 mb-5">
          <div className="from-pink-600 to-purple-500 bg-linear-to-br bg-clip-text">
            <h1 className="hidden text-3xl text-transparent font-bold sm:block">Você foi indicado</h1>
          </div>
          <p className="hidden text-3xl text-muted-foreground sm:block">por um colaborador da Nova ISP</p>
        </div>
        {/* <p className="hidden text-muted-foreground mb-8 sm:block">Preencha seus dados e nossa equipe verificará a cobertura e condições do seu endereço</p> */}
        <Informations />
      </div>
      <div className="w-full order-1 sm:text-center sm:order-2">
        <div className="max-w-md mx-auto from-pink-600 to-purple-500 bg-linear-to-br bg-clip-text">
          <h1 className="max-w-md mx-auto text-3xl text-transparent font-bold">Quero saber mais</h1>
        </div>
        <div className="max-w-lg mx-auto mt-5">
          <IndicateForm />
        </div>
      </div>
    </div>
  );
}
